<app-header-style-seven></app-header-style-seven>

<div *ngIf="loadingMeta" class="status-banner">
  Loading academic year and course list...
</div>

<div *ngIf="metaLoadError" class="status-banner error-banner">
  {{ metaLoadError }}
</div>

<div class="inquiry-page">
  <section class="hero-section">
    <div class="hero-bg-shape hero-bg-shape-one"></div>
    <div class="hero-bg-shape hero-bg-shape-two"></div>

    <div class="hero-content">
      <div class="hero-copy">
        <span class="hero-badge">Admissions Open 2026</span>
        <h1>Admission Enquiry Form</h1>
        <p>
          Share your details and our admission team will contact you with
          programme information, eligibility guidance, and next-step support.
        </p>

        <div class="hero-meta">
          <span>UG & PG Programmes</span>
          <span>Anna University Affiliated</span>
          <span>NAAC A+ Accredited</span>
        </div>
      </div>
    </div>
  </section>

  <section class="page-shell">
    <div class="page-grid">
      <div class="form-card">
        <div class="card-head">
          <div>
            <div class="card-kicker">Public Website Enquiry</div>
            <h2>Fill your enquiry details</h2>
            <p>
              All marked fields are required. Please enter a valid mobile number
              and choose your preferred course.
            </p>
          </div>
        </div>

        <div *ngIf="submitError" class="status-banner error-banner">
          {{ submitError }}
        </div>

        <form class="enquiry-form" (submit)="submitInquiry($event)" novalidate>
          <div class="form-grid">
            <div
              class="field-group full-width"
              [class.has-error]="shouldShowError('student_name')"
            >
              <label for="student_name">Student Name <span>*</span></label>
              <input
                id="student_name"
                type="text"
                [value]="form.student_name"
                (input)="onFieldInput('student_name', $event)"
                (focus)="onFieldFocus('student_name')"
                (blur)="onFieldBlur('student_name')"
                placeholder="Enter student full name"
                autocomplete="name"
              />
              <div class="field-meta">
                <small
                  class="field-help"
                  *ngIf="shouldShowHelper('student_name')"
                >
                  {{ helperTexts.student_name }}
                </small>
                <small
                  class="field-error"
                  *ngIf="shouldShowError('student_name')"
                >
                  {{ getFieldError('student_name') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('gender')"
            >
              <label for="gender">Gender</label>
              <select
                id="gender"
                [value]="form.gender"
                (change)="onFieldInput('gender', $event)"
                (focus)="onFieldFocus('gender')"
                (blur)="onFieldBlur('gender')"
              >
                <option value="">Select gender</option>
                <option *ngFor="let item of genderOptions" [value]="item">
                  {{ item }}
                </option>
              </select>
              <div class="field-meta">
                <small class="field-help" *ngIf="shouldShowHelper('gender')">
                  {{ helperTexts.gender }}
                </small>
                <small class="field-error" *ngIf="shouldShowError('gender')">
                  {{ getFieldError('gender') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('phone')"
            >
              <label for="phone">Mobile Number <span>*</span></label>
              <input
                id="phone"
                type="tel"
                [value]="form.phone"
                (input)="onFieldInput('phone', $event)"
                (focus)="onFieldFocus('phone')"
                (blur)="onFieldBlur('phone')"
                placeholder="Enter 10-digit mobile number"
                inputmode="numeric"
                maxlength="10"
                autocomplete="tel"
              />
              <div class="field-meta">
                <small class="field-help" *ngIf="shouldShowHelper('phone')">
                  {{ helperTexts.phone }}
                </small>
                <small class="field-error" *ngIf="shouldShowError('phone')">
                  {{ getFieldError('phone') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('email')"
            >
              <label for="email">Email Address</label>
              <input
                id="email"
                type="email"
                [value]="form.email"
                (input)="onFieldInput('email', $event)"
                (focus)="onFieldFocus('email')"
                (blur)="onFieldBlur('email')"
                placeholder="Enter email address"
                autocomplete="email"
              />
              <div class="field-meta">
                <small class="field-help" *ngIf="shouldShowHelper('email')">
                  {{ helperTexts.email }}
                </small>
                <small class="field-error" *ngIf="shouldShowError('email')">
                  {{ getFieldError('email') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('parent_name')"
            >
              <label for="parent_name">Parent / Guardian Name</label>
              <input
                id="parent_name"
                type="text"
                [value]="form.parent_name"
                (input)="onFieldInput('parent_name', $event)"
                (focus)="onFieldFocus('parent_name')"
                (blur)="onFieldBlur('parent_name')"
                placeholder="Enter parent or guardian name"
              />
              <div class="field-meta">
                <small
                  class="field-help"
                  *ngIf="shouldShowHelper('parent_name')"
                >
                  {{ helperTexts.parent_name }}
                </small>
                <small
                  class="field-error"
                  *ngIf="shouldShowError('parent_name')"
                >
                  {{ getFieldError('parent_name') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('academic_year_id')"
            >
              <label for="academic_year_id">Academic Year <span>*</span></label>
              <select
                id="academic_year_id"
                [value]="form.academic_year_id ?? ''"
                (change)="onNumberFieldInput('academic_year_id', $event)"
                (focus)="onFieldFocus('academic_year_id')"
                (blur)="onFieldBlur('academic_year_id')"
              >
                <option value="">Select academic year</option>
                <option *ngFor="let item of academicYears" [value]="item.id">
                  {{ item.label }}
                </option>
              </select>
              <div class="field-meta">
                <small
                  class="field-help"
                  *ngIf="shouldShowHelper('academic_year_id')"
                >
                  {{ helperTexts.academic_year_id }}
                </small>
                <small
                  class="field-error"
                  *ngIf="shouldShowError('academic_year_id')"
                >
                  {{ getFieldError('academic_year_id') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('preferred_course_id')"
            >
              <label for="preferred_course_id"
                >Preferred Course <span>*</span></label
              >
              <select
                id="preferred_course_id"
                [value]="form.preferred_course_id ?? ''"
                (change)="onNumberFieldInput('preferred_course_id', $event)"
                (focus)="onFieldFocus('preferred_course_id')"
                (blur)="onFieldBlur('preferred_course_id')"
              >
                <option value="">Select preferred course</option>
                <option *ngFor="let item of courseOptions" [value]="item.id">
                  {{ item.label }}
                </option>
              </select>
              <div class="field-meta">
                <small
                  class="field-help"
                  *ngIf="shouldShowHelper('preferred_course_id')"
                >
                  {{ helperTexts.preferred_course_id }}
                </small>
                <small
                  class="field-error"
                  *ngIf="shouldShowError('preferred_course_id')"
                >
                  {{ getFieldError('preferred_course_id') }}
                </small>
              </div>
            </div>

            <div
              class="field-group"
              [class.has-error]="shouldShowError('preferred_time')"
            >
              <label for="preferred_time">Preferred Contact Time</label>
              <select
                id="preferred_time"
                [value]="form.preferred_time"
                (change)="onFieldInput('preferred_time', $event)"
                (focus)="onFieldFocus('preferred_time')"
                (blur)="onFieldBlur('preferred_time')"
              >
                <option value="">Select preferred time</option>
                <option *ngFor="let item of preferredTimeOptions" [value]="item">
                  {{ item }}
                </option>
              </select>
              <div class="field-meta">
                <small
                  class="field-help"
                  *ngIf="shouldShowHelper('preferred_time')"
                >
                  {{ helperTexts.preferred_time }}
                </small>
                <small
                  class="field-error"
                  *ngIf="shouldShowError('preferred_time')"
                >
                  {{ getFieldError('preferred_time') }}
                </small>
              </div>
            </div>

            <div
              class="field-group full-width"
              [class.has-error]="shouldShowError('address')"
            >
              <label for="address">Address</label>
              <textarea
                id="address"
                rows="3"
                [value]="form.address"
                (input)="onFieldInput('address', $event)"
                (focus)="onFieldFocus('address')"
                (blur)="onFieldBlur('address')"
                placeholder="Enter your address"
              ></textarea>
              <div class="field-meta">
                <small class="field-help" *ngIf="shouldShowHelper('address')">
                  {{ helperTexts.address }}
                </small>
                <small class="field-error" *ngIf="shouldShowError('address')">
                  {{ getFieldError('address') }}
                </small>
              </div>
            </div>

            <div
              class="field-group full-width"
              [class.has-error]="shouldShowError('remarks')"
            >
              <label for="remarks">Remarks / Enquiry Message</label>
              <textarea
                id="remarks"
                rows="4"
                [value]="form.remarks"
                (input)="onFieldInput('remarks', $event)"
                (focus)="onFieldFocus('remarks')"
                (blur)="onFieldBlur('remarks')"
                placeholder="Write your enquiry, admission interest, or support needed"
              ></textarea>
              <div class="field-meta">
                <small class="field-help" *ngIf="shouldShowHelper('remarks')">
                  {{ helperTexts.remarks }}
                </small>
                <small class="field-error" *ngIf="shouldShowError('remarks')">
                  {{ getFieldError('remarks') }}
                </small>
              </div>
            </div>
          </div>

          <label
            class="consent-box"
            [class.has-error]="shouldShowError('consent')"
          >
            <input
              type="checkbox"
              [checked]="form.consent"
              (change)="onConsentChange($event)"
              (focus)="onFieldFocus('consent')"
              (blur)="onFieldBlur('consent')"
            />
            <span>
              I agree to share my details with FMCET for admission counselling
              and follow-up communication. <strong>*</strong>
            </span>
          </label>

          <div class="field-meta consent-meta">
            <small class="field-help" *ngIf="shouldShowHelper('consent')">
              {{ helperTexts.consent }}
            </small>
            <small class="field-error" *ngIf="shouldShowError('consent')">
              {{ getFieldError('consent') }}
            </small>
          </div>

          <div class="form-actions">
            <button
              type="submit"
              class="submit-btn"
              [disabled]="submitting || loadingMeta"
            >
              {{ submitting ? 'Submitting...' : 'Submit Enquiry' }}
            </button>

            <button
              type="button"
              class="reset-btn"
              [disabled]="submitting"
              (click)="resetForm()"
            >
              Reset Form
            </button>
          </div>
        </form>
      </div>

      <aside class="info-column">


        <div class="info-card">
          <div class="info-card-kicker">Popular Programmes</div>
          <h3>Courses available</h3>

          <div class="course-pills">
            <span *ngFor="let item of courseOptions">{{ item.label }}</span>
          </div>
        </div>

        <div class="contact-card">
          <h3>Contact the Admission Office</h3>
          <p>Fatima Michael College of Engineering &amp; Technology, Madurai</p>
          <p>Email: principal&#64;fmcet.ac.in</p>
          <p>Email: mr&#64;fmcet.ac.in</p>
          <a href="tel:+919942982322">+91 99429 82322</a><br />
          <a href="tel:+919942982321">+91 99429 82321</a><br />
          <a href="tel:+919942982311">+91 99429 82311</a>

          <div class="contact-actions">
            <a routerLink="/contact" class="contact-link">Visit Contact Page</a>
          </div>
        </div>
      </aside>
    </div>
  </section>
</div>

<div class="success-popup-overlay" *ngIf="showSuccessPopup">
  <div class="success-popup-card">
    <div class="popup-icon">✓</div>

    <h3>{{ popupTitle }}</h3>

    <p>
      {{ popupMessage }}
    </p>

    <p class="popup-ref" *ngIf="popupEnquiryId">
      Reference No: <strong>{{ popupEnquiryId }}</strong>
    </p>

    <div class="popup-actions">
      <button type="button" class="popup-btn" (click)="closeSuccessPopup()">
        OK
      </button>
    </div>
  </div>
</div>